module.exports = __webpack_public_path__ + "static/media/avatar_owl.0c7b6d57.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_owl.png
// module id = 391
// module chunks = 0